import { css } from 'styled-components';
import {
  getSpacing, SpacingName, ThemedFunctor,
} from '@doveit/lego';

export const item: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.MEDIUM, SpacingName.ZERO])}
  border-top: 1px solid ${theme.palettes.neutrals.light};

  &:first-of-type {
    border-top: 0;
    padding-top: 0;
  }
`;

export const pagination: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
  display: flex;
  justify-content: center;
`;
